const init = (callback) => {
  document.addEventListener("click", function (e) {
    if (e.target && e.target.className === "glossary-item") {
      e.preventDefault();
      callback(e.target.getAttribute("href").substring(1));
    }
  });
};

export default init;
